import { blockCategories } from '../../categories';
import { openMediaPickerModal } from '../../../services/mediaPickerModal';
import {
    applyBsImageMediaResult,
    BS_IMAGE_FIGURE_TYPE,
    BS_IMAGE_IMG_TYPE,
    BS_IMAGE_PLACEHOLDER_SRC,
    initImageFigureStyleSync,
    registerCaptionComponent,
    registerCaptionEditorEvents,
    registerFigureCaptionType,
    registerImageFigureBehavior,
    resolveBsImageFigure,
} from './imageCaption';

export const img_src_default = BS_IMAGE_PLACEHOLDER_SRC;

export {
    applyBsImageMediaResult,
    BS_IMAGE_CAPTION_TYPE,
    BS_IMAGE_FIGURE_TYPE,
    BS_IMAGE_IMG_TYPE,
    extractMediaDescription,
    getCaptionText,
    resolveBsImageFigure,
    resolveBsImageImg,
    setFigureCaptionFromDescription,
} from './imageCaption';

export const imageTraits = [
    {
        type: 'media-library-select',
        label: false,
    },
    {
        type: 'text',
        label: 'Source (URL)',
        name: 'src',
    },
    {
        type: 'text',
        label: 'title',
        name: 'title',
    },
    {
        type: 'text',
        label: 'Alternate text',
        name: 'alt',
    },
    {
        type: 'focal-point',
        label: false,
        name: 'focal-point',
        property: 'object-position',
    },
    {
        type: 'size-with-unit',
        label: false,
        name: 'width',
        property: 'width',
        displayLabel: 'Breite',
    },
    {
        type: 'size-with-unit',
        label: false,
        name: 'height',
        property: 'height',
        displayLabel: 'Höhe',
    },
    {
        type: 'checkbox',
        label: 'Priorität laden',
        name: 'priorityLoad',
        changeProp: 1,
    },
    {
        type: 'responsive-sizes',
        label: false,
        name: 'responsiveSizes',
    },
];

const imageMediaPickerView = {
    events: {
        dblclick: 'openMediaLibrary',
    },
    onRender() {
        if (this._autoOpenedMediaPicker) return;

        const attrs = this.model.get('attributes') || {};
        const src = attrs.src || this.el?.getAttribute?.('src');
        if (!src || src === img_src_default) {
            this._autoOpenedMediaPicker = true;
            this.openMediaLibrary();
        }
    },
    openMediaLibrary(e) {
        e?.stopPropagation?.();
        openMediaPickerModal({
            allowedTypes: ['image'],
            title: 'Bild auswählen',
        }).then((result) => {
            if (!result?.url) return;
            applyBsImageMediaResult({
                imageTarget: this.model,
                figure: resolveBsImageFigure(this.model),
                result,
            });
        });
    },
};

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    const imageType = domComponents.getType('image');
    const model = imageType.model;
    const view = imageType.view;
    const textType = domComponents.getType('text');
    const textModel = textType.model;
    const textView = textType.view;

    const captionEditor = registerCaptionComponent(
        domComponents,
        editor,
        textModel,
        textView
    );

    domComponents.addType(BS_IMAGE_IMG_TYPE, {
        extend: 'image',
        model: {
            defaults: Object.assign({}, model.prototype.defaults, {
                'custom-name': 'Image',
                tagName: 'img',
                resizable: 1,
                // Show move toolbar icon; actual drag/clone/delete targets the figure.
                draggable: true,
                droppable: false,
                delegate: {
                    move: (cmp) => resolveBsImageFigure(cmp) || cmp,
                    copy: (cmp) => resolveBsImageFigure(cmp) || cmp,
                    remove: (cmp) => resolveBsImageFigure(cmp) || cmp,
                },
                attributes: {
                    src: img_src_default,
                },
                classes: ['sio-image'],
                traits: imageTraits.concat(model.prototype.defaults.traits),
            }),
            init() {
                initImageFigureStyleSync(this);
            },
        },
        isComponent(el) {
            if (
                el?.tagName === 'IMG' &&
                el.classList?.contains('sio-image') &&
                !el.classList.contains('sio-gallery-image')
            ) {
                return { type: BS_IMAGE_IMG_TYPE };
            }
        },
        view: Object.assign({}, view, {
            events: Object.assign({}, view.events || {}, imageMediaPickerView.events),
            onRender: imageMediaPickerView.onRender,
            openMediaLibrary: imageMediaPickerView.openMediaLibrary,
        }),
    });

    registerFigureCaptionType(domComponents);
    registerImageFigureBehavior(editor);
    registerCaptionEditorEvents(editor, captionEditor);

    blockManager.add('bs-image', {
        label: 'Bild',
        category: blockCategories.basic,
        content: {
            type: BS_IMAGE_FIGURE_TYPE,
        },
        media: `<svg fill="currentColor" aria-hidden="true"  focusable="false" data-prefix="fas" data-icon="image" class="svg-inline--fa fa-image fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"></path></svg>`,
    });
};
